export default "__VITE_ASSET__84cad7be__"